if (!customElements.get('quick-size-add')) {
  customElements.define('quick-size-add', class QuickSizeAdd extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.toggleBtn = this.querySelector('.js-quick-size-toggle');
      this.sizePopover = this.querySelector('.js-quick-size-popover');
      this.sizeButtons = this.querySelectorAll('.js-quick-size-btn');
      this.spinner = this.toggleBtn.querySelector('.loading-overlay__spinner');
      this.variantData = this.getVariantData();

      this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
      this.sizeButtons.forEach(btn => {
        btn.addEventListener('click', this.onSizeClick.bind(this));
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.closePopover();
      });
    }

    getVariantData() {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return [];
      try { return JSON.parse(script.textContent); } catch { return []; }
    }

    onToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!this.sizePopover || this.variantData.length === 0) {
        const defaultId = this.dataset.defaultVariant;
        if (defaultId) this.addToCart(defaultId);
        return;
      }

      this.sizePopover.classList.toggle('is-active');
    }

    closePopover() {
      if (this.sizePopover) this.sizePopover.classList.remove('is-active');
      this.sizeButtons.forEach(b => b.classList.remove('is-selected'));
    }

    setLoading(loading) {
      if (loading) {
        this.toggleBtn.classList.add('loading');
        this.spinner.classList.remove('hidden');
        this.sizeButtons.forEach(b => b.disabled = true);
      } else {
        this.toggleBtn.classList.remove('loading');
        this.spinner.classList.add('hidden');
        this.sizeButtons.forEach(b => b.disabled = false);
      }
    }

    onSizeClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = e.currentTarget.dataset.variantId;
      if (!variantId) return;

      this.sizeButtons.forEach(b => b.classList.remove('is-selected'));
      e.currentTarget.classList.add('is-selected');
      this.addToCart(variantId);
    }

    addToCart(variantId) {
      this.setLoading(true);

      const sections = this.cart ? this.cart.getSectionsToRender().map(s => s.id) : [];

      const body = JSON.stringify({
        id: parseInt(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body
      })
        .then(r => r.json())
        .then(response => {
          if (response.status) {
            console.error('Error adding to cart:', response.description);
            return;
          }

          document.dispatchEvent(
            new CustomEvent('variant:add', {
              detail: {
                variant: { id: variantId },
                quantity: 1,
              },
            })
          );

          if (this.cart) {
            this.cart.renderContents(response);
          }
          this.closePopover();
        })
        .catch(e => console.error(e))
        .finally(() => {
          this.setLoading(false);
        });
    }
  });
}
